export default __webpack_public_path__ + "static/media/dropbox.9d61ebe9.svg";